import { takeLatest, call, put } from "redux-saga/effects";

import api from "Util/api";

// Actions
const types = {
    GET_FACTORS_REQUESTED: "GET_FACTORS_REQUESTED",
    GET_FACTORS_SUCCEEDED: "GET_FACTORS_SUCCEEDED",
    GET_FACTORS_FAILED: "GET_FACTORS_FAILED"
};

// Action Creators
export const actions = {
    get: callback => {
        return {
            type: types.GET_FACTORS_REQUESTED,
            callback
        };
    }
};

// Default state
const defaultState = {
    data: [],
    error: "",
    loading: true
};

// Reducers
export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case types.GET_FACTORS_REQUESTED:
            return {
                ...state,
                loading: true
            };
        case types.GET_FACTORS_SUCCEEDED:
            return {
                ...state,
                data: action.payload.data,
                loading: false
            };
        case types.GET_FACTORS_FAILED:
            return {
                ...state,
                error: action.error,
                loading: false
            };
        default:
            return state;
    }
}

// Sagas
export function* saga() {
    yield takeLatest(types.GET_FACTORS_REQUESTED, startGetNormsWorker);
}

// Saga callback
function* startGetNormsWorker({ callback }) {
    try {
        const response = yield call(get);

        if (!response.ok) {
            throw response.data;
        }

        yield put({
            type: types.GET_FACTORS_SUCCEEDED,
            payload: response.data
        });

        typeof callback == "function" && callback(response.data);
    } catch (e) {
        console.error({ e });
        yield put({ type: types.GET_FACTORS_FAILED, error: e.error });
    }
}

// API call
function get() {
    return api.get(`/api/personality-test/factors`);
}
